import { useEffect } from "react";
import { useAuth } from "../context";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

function AuthHandler() {
  const toast = useToast();
  const navigate = useNavigate();
  const { expiry, logout } = useAuth();

  useEffect(() => {
    if (expiry) {
      const now = Date.now();
      const timeout = expiry * 1000 - now;
      const timeoutId = setTimeout(() => {
        logout();
        navigate("/");
        toast({
          title: "Logout",
          description: "You have been logged out because your session expired. To continue, log in again.",
          status: "warning",
          duration: null,
          isClosable: true,
        });
      }, timeout);

      return () => clearTimeout(timeoutId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiry]);

  return null;
}

export default AuthHandler;
